<template>
  <div id="app">
    <!--头部导航-->
    <!-- <banner></banner> -->
    <router-view></router-view>

    <el-button
      icon="el-icon-caret-top"
      circle
      class="goTop"
      @click="goTop()"
    ></el-button>

    <!-- 服务协议版 -->
    <!-- <service></service> -->

    <!-- 隐私政策版 -->
    <!-- <privacy /> -->
  </div>
</template>
<script>
// import banner from "./components/banner";
import service from "./components/service";
import privacy from "./components/privacy";
export default {
  name: "App",
  components: {
    // banner,
    service,
    privacy,
  },
  methods: {
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* background-image: url(./assets/back.png);  app官网版
  background-size: contain;
  background-position: center; 
  height: 3960px; */
}
.goTop {
  position: fixed;
  right: 50px;
  bottom: 50px;
  z-index: 9999;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  z-index: 5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue